// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MailChimp Campaigns Styles
 * Modern, responsive styles for MailChimp campaigns management
 */

.mailchimp-campaigns {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.campaigns-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}



/* Campaigns Content */
.campaigns-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}


/* Campaigns Table Container */
.campaigns-table-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow-x: auto;
}

.campaigns-table {
  min-width: 100%;
  width: max-content;
}

.campaigns-table table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
}

.campaigns-table th {
  background: rgba(13, 59, 102, 0.1);
  color: #2d3748;
  font-weight: 600;
  padding: 16px;
  text-align: left;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
}

.campaigns-table th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.3s ease;
}

.campaigns-table th.sortable:hover {
  background: rgba(13, 59, 102, 0.15);
  color: #0D3B66;
}

.sort-indicator {
  margin-left: 8px;
  font-size: 0.8rem;
  color: #0D3B66;
  font-weight: bold;
}

.campaigns-table td {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #4a5568;
  white-space: nowrap;
  vertical-align: top;
}

.campaigns-table tr:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Campaign Title */
.campaign-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title-text {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.campaign-id {
  color: #718096;
  font-size: 0.75rem;
  font-family: monospace;
}

/* Campaign Subject */
.campaign-subject {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.subject-line {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.from-name {
  color: #4a5568;
  font-size: 0.8rem;
}

/* Campaign Type */
.campaign-type {
  display: inline-block;
  padding: 4px 8px;
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

/* Emails Count */
.emails-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

/* Send Time */
.send-time {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.time-sent {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 500;
}

.time-sent small {
  color: #718096;
  font-size: 0.75rem;
  font-weight: 400;
}

.not-sent {
  color: #a0aec0;
  font-size: 0.8rem;
  font-style: italic;
}

/* Open Rate */
.open-rate {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rate-value {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 600;
}

.rate-value small {
  color: #718096;
  font-size: 0.75rem;
  font-weight: 400;
}

.no-data {
  color: #a0aec0;
  font-size: 0.8rem;
  font-style: italic;
}

/* Click Rate */
.click-rate {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.save {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.status-badge.paused {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

.status-badge.schedule {
  background: rgba(49, 130, 206, 0.1);
  color: #3182ce;
}

.status-badge.sending {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
}

.status-badge.sent {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.status-badge.cancelled {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

/* Campaign Actions */
.campaign-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.6;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.empty-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.8rem;
}

.btn-icon {
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mailchimp-campaigns {
    padding: 16px;
  }

  .campaigns-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }



  .campaigns-table-container {
    overflow-x: auto;
  }

  .campaigns-table table {
    min-width: 1000px;
  }
}

@media (max-width: 480px) {
  .mailchimp-campaigns {
    padding: 12px;
  }

  .campaigns-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mailchimp/MailChimpCampaigns.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;;;AAIA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;AAC5C;;;AAGA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB;;iCAE+B;EAC/B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;;;EAIA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * MailChimp Campaigns Styles\n * Modern, responsive styles for MailChimp campaigns management\n */\n\n.mailchimp-campaigns {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.campaigns-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n\n\n/* Campaigns Content */\n.campaigns-content {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n\n/* Campaigns Table Container */\n.campaigns-table-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  overflow-x: auto;\n}\n\n.campaigns-table {\n  min-width: 100%;\n  width: max-content;\n}\n\n.campaigns-table table {\n  width: 100%;\n  min-width: 1200px;\n  border-collapse: collapse;\n}\n\n.campaigns-table th {\n  background: rgba(13, 59, 102, 0.1);\n  color: #2d3748;\n  font-weight: 600;\n  padding: 16px;\n  text-align: left;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n}\n\n.campaigns-table th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.3s ease;\n}\n\n.campaigns-table th.sortable:hover {\n  background: rgba(13, 59, 102, 0.15);\n  color: #0D3B66;\n}\n\n.sort-indicator {\n  margin-left: 8px;\n  font-size: 0.8rem;\n  color: #0D3B66;\n  font-weight: bold;\n}\n\n.campaigns-table td {\n  padding: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  color: #4a5568;\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.campaigns-table tr:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n/* Campaign Title */\n.campaign-title {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.title-text {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.campaign-id {\n  color: #718096;\n  font-size: 0.75rem;\n  font-family: monospace;\n}\n\n/* Campaign Subject */\n.campaign-subject {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.subject-line {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.from-name {\n  color: #4a5568;\n  font-size: 0.8rem;\n}\n\n/* Campaign Type */\n.campaign-type {\n  display: inline-block;\n  padding: 4px 8px;\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n/* Emails Count */\n.emails-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n/* Send Time */\n.send-time {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.time-sent {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.time-sent small {\n  color: #718096;\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\n.not-sent {\n  color: #a0aec0;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n/* Open Rate */\n.open-rate {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.rate-value {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.rate-value small {\n  color: #718096;\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\n.no-data {\n  color: #a0aec0;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n/* Click Rate */\n.click-rate {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.save {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.status-badge.paused {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n.status-badge.schedule {\n  background: rgba(49, 130, 206, 0.1);\n  color: #3182ce;\n}\n\n.status-badge.sending {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n}\n\n.status-badge.sent {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.status-badge.cancelled {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n/* Campaign Actions */\n.campaign-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.8rem;\n}\n\n.btn-icon {\n  font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .mailchimp-campaigns {\n    padding: 16px;\n  }\n\n  .campaigns-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n\n\n  .campaigns-table-container {\n    overflow-x: auto;\n  }\n\n  .campaigns-table table {\n    min-width: 1000px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mailchimp-campaigns {\n    padding: 12px;\n  }\n\n  .campaigns-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
